var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro-xs"},[_c('div',{staticClass:"col-50 flex column nowrap justify-center align-center animated fadeInLeft"},[_c('div',{staticClass:"container-text"},[_c('h1',{staticClass:"title title-52",domProps:{"innerHTML":_vm._s(_vm.$t('trabaja_con_nosotros.intro.titulo'))}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89ecb102","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/intros/trabaja-con-nosotros.vue
// module id = null
// module chunks = 